<div class="table-responsive">
  <table class="table table-hover align-middle">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Email</th>
        <th>Roles</th>
        <th>Status</th>
        <ng-container *ngIf="showActions">
          <th *appSubRole="[subRole.ADMINISTRATOR]">Action</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of subUsers; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ user.userName }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.subRoles.join(', ') || '-' }}</td>
        <td>
          <span [class]="user.isActive ? 'anq-status-success' : 'anq-status-danger'">
            {{ user.isActive ? 'Active' : 'Deactivated' }}
          </span>
        </td>
        <ng-container *ngIf="showActions">
          <td *appSubRole="[subRole.ADMINISTRATOR]">
            <div ngbDropdown container="body">
              <i class="fa fa-ellipsis-vertical anq-table-action" ngbDropdownToggle></i>
              <div ngbDropdownMenu>
                <a
                  ngbDropdownItem
                  [class]="user.isActive ? 'text-danger' : 'text-success'"
                  (click)="toggleStatus.emit(user)"
                >
                  {{ user.isActive ? 'Deactivate' : 'Activate' }}
                </a>
              </div>
            </div>
          </td>
        </ng-container>
      </tr>

      <tr class="empty-table" *ngIf="!subUsers || subUsers.length === 0">
        <td valign="top" colspan="20">
          <app-empty-datatable [message]="'No sub users found'"></app-empty-datatable>
        </td>
      </tr>
    </tbody>
  </table>
</div>
